import { ConfigType } from '../../abstract/Form';
import { EthnicityType } from '../../types';
export const config: ConfigType = {
    right: [
        {
            label: "Patient Background",
            rows: [
                {
                    fields: [
                        {
                            name: "name",
                            label: "Name",
                            type: "text",
                            required: true
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "birth",
                            label: "Birth Date",
                            type: "date",
                            required: true
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "height",
                            label: "Height",
                            type: "height",
                            required: true
                        },
                        {
                            name: "weight",
                            label: "Weight",
                            type: "weight",
                            required: true
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "ethnicity",
                            label: "Ethnicity",
                            type: "tag-select",
                            required: true,
                            options: Object.keys(EthnicityType).map((key) => ({ value: key, label: EthnicityType[key as keyof typeof EthnicityType].toString() }))
                        },
                    ]
                }

            ]
        },
        {
            label: "Cycle Details",
            rows: [
                {
                    fields: [
                        {
                            name: "type",
                            label: "Type",
                            type: "button-selection",
                            required: true,
                            options: [
                                { value: "natural", label: "Natural Cycle" },
                                { value: "hormone", label: "Hormone Replacement Cycle" },
                            ]
                        },
                        {
                            name: "start_date",
                            label: "Start Date",
                            type: "date",
                            required: true
                        },

                    ]
                }
            ]
        },

        {
            label: "Endometrial & Hormonal Levels",
            subsections: [
                {
                    label: "Endometrial Thickness",
                    rows: [
                        {
                            fields: [
                                {
                                    name: "thickness",
                                    label: "Thickness",
                                    type: "number",
                                    adornment: "mm",
                                    required: true
                                },
                                {
                                    name: "measurement.date",
                                    label: "Measurement date",
                                    type: "date",
                                    required: true

                                }
                            ]
                        },
                    ]
                },
                {
                    label: "Hormonal Levels",
                    rows: [
                        {
                            fields: [
                                {
                                    name: "progesterone",
                                    label: "Progesterone levels",
                                    type: "number",
                                    adornment: "ng/mL",
                                    required: true
                                },
                                {
                                    name: "estrogen",
                                    label: "Estrogen levels",
                                    type: "number",
                                    adornment: "pg/mL",
                                    required: true
                                },
                            ]
                        },
                    ]

                }
            ]
        }, {
            label: "Endometrial Biopsy",
            rows: [
                {
                    fields: [
                        {
                            name: "biopsy",
                            label: "Biopsy Performed",
                            type: "button-selection",
                            options: [
                                { value: "yes", label: "Yes" },
                                { value: "no", label: "No" },
                            ],
                            required: false
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "biopsy_date",
                            label: "Biopsy Date",
                            type: "date",
                            required: false
                        },
                    ]
                },
                {
                    fields: [
                        {
                            name: "biopsy.timing",
                            label: "Biopsy Timing",
                            type: "button-selection",
                            options: [
                                { value: "lh7", label: "LH + 7" },
                                { value: "p5", label: "P + 5" },
                            ],
                            required: false
                        },
                    ]
                }
            ]
        }


    ], left: []
};